import { Component, inject, signal, ChangeDetectionStrategy } from "@angular/core";
import { AsinSelectionComponent } from "@m19-board/shared/asin-selection/asin-selection.component";
import { MODAL_DATA } from "@front/m19-ui";

@Component({
  selector: "app-asin-selection-modal",
  imports: [AsinSelectionComponent],
  template: ` <div class="flex h-full min-h-0 flex-col">
    <app-asin-selection class="min-h-0 flex-1" [readonly]="readonly()" [customList]="asins()" />
  </div>`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsinSelectionModalComponent {
  private readonly modalData = inject<AsinSelectionModalData>(MODAL_DATA);

  readonly = signal<boolean>(!!this.modalData.readonly);
  asins = signal<string[]>(this.modalData.asins ?? []);
}

export interface AsinSelectionModalData {
  readonly?: boolean;
  asins?: string[];
}
